import {
  Row,
  VertButton,
  VertContainer,
  VertTypography,
} from '@vertem-core/vertice-ds';
import { Space } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const BoxFilterPoints = ({ valuePoints, path, icon, label }) => {
  const Catalog = useSelector(({ Catalog: data }) => data);
  const {
    currencyConfiguration: { pointsName },
  } = Catalog;

  return (
    <Space direction="vertical" size={0} className="box-space-filter-points">
      <Link to={path} className="box-filter-points">
        <VertTypography.Text className="box-filter-points__title">
          {label}
        </VertTypography.Text>
        <VertTypography.Text className="box-filter-points__qtd">
          <span className="box-filter-points__qtd__value">{valuePoints}</span>
          <span className="box-filter-points__qtd__name">{pointsName}</span>
        </VertTypography.Text>
        <button className="box-filter-points__button">{icon}</button>
      </Link>
    </Space>
  );
};

export default BoxFilterPoints;
